import { useEffect, useState } from 'react';
import { styled, keyframes } from '@mui/material/styles';

interface ShimmerTextProps {
  texts: string[];
}

export const ShimmerText = ({ texts }: ShimmerTextProps) => {
  const [textIndex, setTextIndex] = useState(0);
  const currentText = texts[textIndex] ?? (texts[0] as string);
  const [shimmerIndex, setShimmerIndex] = useState(0);
  const [shimmerDirection, setShimmerDirection] = useState<1 | -1>(1);

  useEffect(() => {
    const interval = setInterval(() => {
      setTextIndex(i => (i + 1) % texts.length);
      setShimmerIndex(0); // Reset shimmer when text changes
      setShimmerDirection(1); // Reset direction when text changes
    }, 10000);

    return () => clearInterval(interval);
  }, [texts.length]);

  // Shimmer animation across characters with bouncing effect
  useEffect(() => {
    const interval = setInterval(() => {
      setShimmerIndex(i => {
        const nextIndex = i + shimmerDirection;

        // Bounce at the boundaries
        if (nextIndex >= currentText.length) {
          setShimmerDirection(-1);
          return currentText.length - 1;
        } else if (nextIndex < 0) {
          setShimmerDirection(1);
          return 0;
        }

        return nextIndex;
      });
    }, 100);

    return () => clearInterval(interval);
  }, [currentText.length, shimmerDirection]);

  return (
    <Container>
      {currentText.split('').map((char, i) => {
        const isShimmering = i === shimmerIndex;
        return (
          <Token isShimmering={isShimmering} key={i}>
            {char}
          </Token>
        );
      })}
    </Container>
  );
};

const shimmer = keyframes`
  0% {
    color: grey;
  }
  50% {
    color: black;
  }
  100% {
    color: grey;
  }
`;

const Container = styled('div')`
  min-height: 1.5em;
`;

const Token = styled('span')<{ isShimmering: boolean }>`
  display: inline;
  transition: color 100ms ease-out;
  animation: ${props => (props.isShimmering ? shimmer : 'none')} 1000ms ease-out;
`;
